import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  Stepper,
  Step,
  StepLabel,
  StepContent
} from '@mui/material';
// Import the image
import { ReactComponent as MassiveBioSVG }from './MassiveBio.svg'; // Adjust path as needed

interface ProcessStep {
  label: string;
  description: string;
}

export const AboutMassiveBio: React.FC = () => {
  // State to track if the image failed to load
  const [imageError, setImageError] = React.useState(false);

  return (
    <>
      {/* About Massive Bio */}
      <Typography 
        variant="h5"
        sx={{
          fontWeight: 'bold',
          mb: 2,
          mt: 4
        }}
      >
        About Massive Bio
      </Typography>
      <Box sx={{
        display: 'flex',  flexDirection:  { xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' }, alignItems: 'flex-start',
        gap: 3      }}>
        <Box sx={{}}>
          {imageError ? (
            // Fallback to original blue box with text if image fails to load
            <Paper
              elevation={0}
              sx={{
                bgcolor: '#003366',
                p: 3,
                borderRadius: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                MASSIVE BIO
              </Typography>
            </Paper>
          ) : (
            // Use the imported image
            <Box sx={{ width: '100%', height: '100%',  }}>
            <MassiveBioSVG width="100%" height="100%" />
          </Box>
          )}
        </Box>
        <Box sx={{}}>
          <Typography variant="body2" paragraph sx={{ fontSize: { xs: 16, sm: 16, md: 18 } }}>
            Massive Bio strives to create a world without cancer by empowering individuals everywhere with equal access to cutting-edge therapies and clinical trials. The company uses AI in combination with its relationship to bridge gaps in different patient outcomes.
          </Typography>
          <Typography variant="body2" paragraph sx={{ fontSize: { xs: 16, sm: 16, md: 18 } }}>
            Through advanced AI-based technology, Massive Bio breaks down barriers, connecting cancer patients worldwide with cancer clinical trials and offering support every step of the way.
          </Typography>
          <Typography variant="body2" paragraph sx={{ fontSize: { xs: 16, sm: 16, md: 18 } }}>
            Collaborating with 17 big pharmaceutical companies, 150+ global healthcare providers, Massive Bio is one of the world's largest direct-to-consumer clinical trial enrollment and matching services in the most advanced cancer clinical trials, operating services in 12 languages and 14 countries.
          </Typography>
          {/* <Button
            variant="outlined"
            size="small"
            sx={{
              borderRadius: 10,
              mt: 1,
              textTransform: 'none',
              borderColor: '#003366',
              color: '#003366',
              '&:hover': {
                borderColor: '#003366',
                backgroundColor: 'rgba(0, 51, 102, 0.04)'
              }
            }}
          >
            Visit Massive Bio Website →
          </Button> */}
        </Box>
      </Box>
    </>
  );
};

//export default ClinicalTrialsInfo;